import "../../../assets/style/AUC1.css";
import { useTranslation } from "react-i18next";

function AUC1() {
    const { t } = useTranslation();

    return (
        <section className='AUC1'>
            <div className='mainAUC1'>
                <img src="/photo/aboutUsBackground.webp"  className='backgroundMainAUC1 goneMobile' alt="background"/>
                <div className='contentMainAUC1 goneMobile'>
                    <h1 className='white'>{t("aboutustitle")}</h1>
                </div>
                <div className="contentMainAUC1Mobile">
                    <h1 className='white'>{t("aboutustitle")}</h1>
                </div>
            </div>
        </section>
    );
};

export default AUC1;